import React from 'react';
import ResetButton from './ResetButton';

const formatTime = sec => {
  if(sec === 0) return "0 seconds";
  const sec_num = parseInt(sec, 10); // don't forget the second param
  let days    = Math.floor(sec_num / (3600*24));
  let hours   = Math.floor((sec_num - (days * 3600 * 24)) / 3600);
  let minutes = Math.floor((sec_num - (days * 3600 * 24) - (hours * 3600)) / 60);
  let seconds = sec_num - (days * 3600 * 24) - (hours * 3600) - (minutes * 60);
  const strbuilder = [];
  if (days > 0) strbuilder.push(`${days} days`);
  if (hours > 0) strbuilder.push(`${hours} hours`);
  if (minutes > 0) strbuilder.push(`${minutes} min`);
  if (seconds > 0) strbuilder.push(`${seconds} sec`);
  if(strbuilder.length === 0) return '-';
  return strbuilder.join(" ");
}

const clearTime = (timer, idleTime) => {
  if(timer%idleTime >= idleTime / 2) return 0;
  return idleTime/2 - (timer%idleTime);
}

export default class Reward extends React.Component {

  constructor(props){
    super(props);
    this.state={
      startTime: props.timer || props.globalTimer,
    };
  }
  componentDidUpdate(newProps){
    if((newProps.timer || newProps.globalTimer)!==this.state.startTime) this.setState({
      startTime: newProps.timer || newProps.globalTimer,
    })
  }

  getDelay = () => {
    return 0;
  }
 
  resetTimer = (delay = 0) => {
    this.setState({ startTime: this.props.globalTimer - delay }, this.props.updateParent(delay));
  }


  render() {
    const {
      reward: { content, timer },
      globalTimer,
    } = this.props;
    const { resetTimer } = this;

    const timeRunning = ((globalTimer - this.state.startTime)/1000).toFixed(0);
    const idleTimer = (((timer - timeRunning) % timer)+timer) % timer;
    return (
      <div className={content.toLowerCase().includes('mythic') ? "reward priority" :"reward"}>
        <ResetButton text='Reset' reset={resetTimer} />
        <div className="content">{content}</div>
        <div className="clear-timer">Clear: {formatTime(clearTime(timeRunning, timer))}</div>
        <div className="idle-timer">Idle: {formatTime(idleTimer === 0 ? timer : idleTimer)}</div>
        <div className={["progress", clearTime(timeRunning, timer) > 0 ? 'wait' : 'clear'].join(" ")}>
          <progress className={clearTime(timeRunning, timer) > 0 ? 'wait' : 'clear' } value={((timer - idleTimer)%timer + timer) % timer} max={timer} />
        </div>
      </div>
    );
  }
}